import Category, { CategoryIndexProps } from 'layouts/Category';
import { reportError } from 'lib/errors';
import { createApolloClient } from 'lib/graphql/apollo';
import { CATEGORY_WITH_POSTS } from 'lib/graphql/queries/category';
import { GetStaticPaths, GetStaticProps } from 'next';
import { CategoryWithPosts } from 'types/category';
import { encode } from 'url-encode-decode';

export const getStaticProps: GetStaticProps<CategoryIndexProps> = async ({ params }) => {
    const client = createApolloClient();

    let { slug } = params;
    slug = encode(slug as string);

    const variables = {
        slug,
        cursor: {
            limit: 9,
            skip: 0,
        },
    };

    const props: CategoryIndexProps = {
        slug,
        variables,
    };

    try {
        const { data, errors, loading, networkStatus } = await client.query<{
            category: CategoryWithPosts;
        }>({
            notifyOnNetworkStatusChange: true,
            query: CATEGORY_WITH_POSTS,
            variables,
        });

        if ((errors && errors.length) || !data) {
            props.error = errors[0];
        } else if (data) {
            props.category = data.category;
            props.loading = loading;
            props.networkStatus = networkStatus;
        }
    } catch (err) {
        //console.error(err);
        reportError(err, {
            metaData: {
                operation: 'graphql query categoryWithPosts',
                slug,
                mode: 'getStaticProps',
            },
            severity: 'warning',
        });
    }

    return {
        props,
        revalidate: 600, // 10 minutes
    };
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
    const paths = [
        { params: { slug: 'music' } },
        { params: { slug: 'videos' } },
        { params: { slug: 'features' } },
        { params: { slug: 'interviews' } },
    ];

    return { paths, fallback: 'blocking' };
};

export default Category;
